/* Mēllo: swaps the fallback picks for Shopify's product recommendations (section rendering). */
(() => {
  const load = async (el) => {
    if (el.dataset.loaded) return;
    el.dataset.loaded = '1';
    try {
      const res = await fetch(el.dataset.url);
      if (!res.ok) return;
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      const fresh = doc.querySelector('[data-related-grid][data-recommended]');
      const grid = el.querySelector('[data-related-grid]');
      if (!fresh || !grid || !fresh.querySelector('[data-card]')) return;
      grid.innerHTML = fresh.innerHTML;
      grid.setAttribute('data-recommended', '');
      el.hidden = false;
      grid.querySelectorAll('[data-card] [data-label]').forEach((l) => { l.dataset.default = l.textContent; });
      if (window.Mello && window.Mello.observeReveal) window.Mello.observeReveal(el);
    } catch (err) {
      /* keep the fallback picks */
    }
  };
  const init = (root = document) => {
    root.querySelectorAll('[data-related][data-url]').forEach((el) => {
      if (!('IntersectionObserver' in window)) { load(el); return; }
      const io = new IntersectionObserver((entries) => {
        if (!entries.some((e) => e.isIntersecting)) return;
        io.disconnect();
        load(el);
      }, { rootMargin: '800px 0px' });
      io.observe(el);
    });
  };
  init();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
